import axios from 'axios';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

const listAllWhitepapers = async (filter, key = '', offset) => {
  console.log('Filter: ', filter);
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogs = await axios
    .get(
      `${apiUrl}/v1/public/whitepapers?filter=${filter}&q=${key}&offset=${offset}`
    )
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
  return blogs;
};

const showWhitepapersDetail = async (id) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogDetail = await axios
    .get(`${apiUrl}/v1/public/whitepapers/${id}`)
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
  return blogDetail;
};

const createNewsletter = async (newsletter) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await axios.post(
    `${apiUrl}/v1/public/crms?source=White paper`, // Changed to "White paper"
    {
      email: newsletter.email,
      firstName: newsletter.firstName,
      lastName: newsletter.lastName,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Page-Route': window.location.pathname,
        'X-Page-Title': document.title,
      },
    }
  );
  return response;
};

const getWhitepaperPdf = async (slug, { email, firstName, lastName }) => {

  console.log("Slug: ", slug)
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await axios.post(
    `${apiUrl}/v1/public/whitepapers/${slug}/pdf`,
    {
      email,
      firstName,
      lastName,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return {
    status: response.status,
    data: response.data.data,
  };
};

export default {
  listAllWhitepapers,
  showWhitepapersDetail,
  createNewsletter,
  getWhitepaperPdf,
};
